import { useState } from 'react';
import { TertiaryButton } from '@ardoq/button';
import { AddIcon } from '@ardoq/icons';
import { CreateNodeInput } from './CreateNodeInput';
import { useMetamodelEditorContext } from '../state';

export const AddNewButton = () => {
  const [isInEditMode, setIsInEditMode] = useState<boolean>(false);
  const { labels } = useMetamodelEditorContext();
  return (
    <>
      {isInEditMode ? (
        <CreateNodeInput onEditEnd={() => setIsInEditMode(false)} />
      ) : (
        <TertiaryButton onClick={() => setIsInEditMode(true)}>
          <AddIcon />
          {labels.addRootButton}
        </TertiaryButton>
      )}
    </>
  );
};
